import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import React from "react";
import InvestorDetailsDisplayOnPDF from "./investorDetailsDisplayOnPDF";
import { vasukiPDFLogo } from "../../assets/images";
import OverviewTemplate from "./overviewPDFTemplate";
import FundPerformanceTemplate from "./fundPerformanceTemplate";
import PortfolioTemplate from "./portfolioTemplate";
import SchemeDocumentTemplate from "./schemeDocumentsTemplate";

// Fix for accessibility issues. Issue # VII26-41
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
  },

  header: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    // backgroundColor: "#0E2841", // Dark blue
    padding: 10,
    borderRadius: 5,
    marginBottom: 20,
  },
  logo: {
    width: 150,
    height: 50,
    alignItems: "flex-end",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerTextContainer: {
    marginLeft: 10,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#ffffff",
  },
  headerRight: {
    alignItems: "flex-end",
  },
  headerSubtitle: {
    fontSize: 8,
    color: "#d3d3d3",
    marginTop: 5,
    textAlign: "right",
  },
  section: {
    marginBottom: 4,
    display: "flex",
    flexDirection: "column",
  },
  normalImage: {
    width: "100%",
    height: "auto",
    marginBottom: 10,
  },
  footer: {
    fontSize: 10,
    fontStyle: "italic",
    textAlign: "center",
    marginTop: 10,
  },

});

const PdfFile = ({
  selectedSchemeOptions,
  tableData,
  schemeDocData,
  overviewData,
  investorDetails,
  aumDataForSpecificScheme,
  investorSchemeDetails,
  schemePortfolioData,
  schemeSectorAllocationData
}) => {

  return (
    <Document
      title="Investor portfolio report"
      subject="Investor portfolio and scheme details"
      author="Vasuki Investor Portal"
      creator="Vasuki Investor Portal"
      producer="Vasuki Investor Portal"
      language="en-US"
      pageMode="useOutlines"
    >
      <Page style={styles.page} bookmark="Overview">
        {/* Header Section */}
        <View style={styles.header}>
          {/* Left Section: Logo and Investor Name */}

          <Image
            style={styles.logo}
            src={vasukiPDFLogo}
            accessible={false}
            alt="Vasuki India Advisors Private Limited Logo"
          />

        </View>

        <View style={styles.normalImage}  >
          {investorDetails && <InvestorDetailsDisplayOnPDF details={investorDetails} />}
        </View>


        <View>
          <OverviewTemplate aumDataForSpecificScheme={aumDataForSpecificScheme} investorSchemeDetails={investorSchemeDetails} schemeOverviewData={overviewData} tableData={tableData} />
        </View>
      </Page>


      <Page style={styles.page} bookmark="Performance">
        <View >
          <FundPerformanceTemplate selectedSchemeOptions={selectedSchemeOptions} schemeFundPerformanceData={tableData} investorInfo={investorDetails} />
        </View>
      </Page>

      <Page style={styles.page} bookmark="Portfolio">
        <View>
          <PortfolioTemplate schemePortfolioData={schemePortfolioData} schemeSectorAllocationData={schemeSectorAllocationData} />
        </View>
      </Page>
      {/* <Page style={styles.page}>
        <View>
          <SchemeDocumentTemplate selectedSchemeOptions={selectedSchemeOptions} documents={schemeDocData} />
        </View>
      </Page> */}
    </Document>
  );
};

export default PdfFile;
